import { Star } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { RolePageData } from '../../types'

interface RoleTestimonialSectionProps {
  data: RolePageData
}

export const RoleTestimonialSection = ({ data }: RoleTestimonialSectionProps) => {
  const { testimonial } = data

  return (
    <section className="w-full py-24 bg-gradient-to-b from-white via-stone-50 to-stone-100">
      <Column className="w-full max-w-4xl mx-auto px-8 gap-8">
        {/* Stars */}
        <Row className="gap-1 justify-center">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className="w-5 h-5 text-amber-400 fill-amber-400"
            />
          ))}
        </Row>

        {/* Quote */}
        <h2 className="text-3xl font-normal text-slate-800 text-center max-w-2xl mx-auto">
          "{testimonial.headline}"
        </h2>

        {/* Author */}
        <Row className="items-center gap-4 justify-center">
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="w-14 h-14 rounded-full object-cover"
          />
          <Column className="gap-0">
            <p className="font-medium text-slate-800">{testimonial.name}</p>
            <p className="text-sm text-slate-500">{testimonial.title}</p>
          </Column>
        </Row>
      </Column>
    </section>
  )
}
